var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 100,
    viewBox: "0 0 87 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_4243)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_11_4243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 22C10 15.3726 15.3726 10 22 10H90V90H22C15.3726 90 10 84.6274 10 78V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22C11 15.9249 15.9249 11 22 11H89V89H22C15.9249 89 11 84.0751 11 78V22Z",
    stroke: "#C1C1E9",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 46.9792C35.5 46.2651 35.6406 45.558 35.9139 44.8983C36.1872 44.2386 36.5877 43.6392 37.0926 43.1343C37.5975 42.6294 38.197 42.2288 38.8567 41.9556C39.5164 41.6823 40.2234 41.5417 40.9375 41.5417C41.6516 41.5417 42.3586 41.6823 43.0183 41.9556C43.6781 42.2288 44.2775 42.6294 44.7824 43.1343C45.2873 43.6392 45.6878 44.2386 45.9611 44.8983C46.2344 45.558 46.375 46.2651 46.375 46.9792C46.375 48.4213 45.8021 49.8043 44.7824 50.8241C43.7627 51.8438 42.3796 52.4167 40.9375 52.4167C39.4954 52.4167 38.1123 51.8438 37.0926 50.8241C36.0729 49.8043 35.5 48.4213 35.5 46.9792ZM40.9375 45.1667C40.4568 45.1667 39.9958 45.3576 39.6559 45.6975C39.316 46.0374 39.125 46.4985 39.125 46.9792C39.125 47.4599 39.316 47.9209 39.6559 48.2608C39.9958 48.6007 40.4568 48.7917 40.9375 48.7917C41.4182 48.7917 41.8792 48.6007 42.2191 48.2608C42.559 47.9209 42.75 47.4599 42.75 46.9792C42.75 46.4985 42.559 46.0374 42.2191 45.6975C41.8792 45.3576 41.4182 45.1667 40.9375 45.1667ZM40.9375 54.8333C39.4954 54.8333 38.1123 55.4062 37.0926 56.4259C36.0729 57.4457 35.5 58.8287 35.5 60.2708C35.5 61.7129 36.0729 63.096 37.0926 64.1157C38.1123 65.1355 39.4954 65.7083 40.9375 65.7083C42.3796 65.7083 43.7627 65.1355 44.7824 64.1157C45.8021 63.096 46.375 61.7129 46.375 60.2708C46.375 58.8287 45.8021 57.4457 44.7824 56.4259C43.7627 55.4062 42.3796 54.8333 40.9375 54.8333ZM39.125 60.2708C39.125 59.7901 39.316 59.3291 39.6559 58.9892C39.9958 58.6493 40.4568 58.4583 40.9375 58.4583C41.4182 58.4583 41.8792 58.6493 42.2191 58.9892C42.559 59.3291 42.75 59.7901 42.75 60.2708C42.75 60.7515 42.559 61.2126 42.2191 61.5525C41.8792 61.8924 41.4182 62.0833 40.9375 62.0833C40.4568 62.0833 39.9958 61.8924 39.6559 61.5525C39.316 61.2126 39.125 60.7515 39.125 60.2708ZM50 46.9792C50 46.4985 50.191 46.0374 50.5309 45.6975C50.8708 45.3576 51.3318 45.1667 51.8125 45.1667H62.6875C63.1682 45.1667 63.6292 45.3576 63.9691 45.6975C64.309 46.0374 64.5 46.4985 64.5 46.9792C64.5 47.4599 64.309 47.9209 63.9691 48.2608C63.6292 48.6007 63.1682 48.7917 62.6875 48.7917H51.8125C51.3318 48.7917 50.8708 48.6007 50.5309 48.2608C50.191 47.9209 50 47.4599 50 46.9792ZM51.8125 58.4583C51.3318 58.4583 50.8708 58.6493 50.5309 58.9892C50.191 59.3291 50 59.7901 50 60.2708C50 60.7515 50.191 61.2126 50.5309 61.5525C50.8708 61.8924 51.3318 62.0833 51.8125 62.0833H62.6875C63.1682 62.0833 63.6292 61.8924 63.9691 61.5525C64.309 61.2126 64.5 60.7515 64.5 60.2708C64.5 59.7901 64.309 59.3291 63.9691 58.9892C63.6292 58.6493 63.1682 58.4583 62.6875 58.4583H51.8125ZM35.5 37.3125C35.5 36.8318 35.691 36.3708 36.0309 36.0309C36.3708 35.691 36.8318 35.5 37.3125 35.5H62.6875C63.1682 35.5 63.6292 35.691 63.9691 36.0309C64.309 36.3708 64.5 36.8318 64.5 37.3125C64.5 37.7932 64.309 38.2542 63.9691 38.5941C63.6292 38.934 63.1682 39.125 62.6875 39.125H37.3125C36.8318 39.125 36.3708 38.934 36.0309 38.5941C35.691 38.2542 35.5 37.7932 35.5 37.3125ZM36.1042 28.25C34.0211 28.25 32.0234 29.0775 30.5504 30.5504C29.0775 32.0234 28.25 34.0211 28.25 36.1042V63.8958C28.25 65.9789 29.0775 67.9766 30.5504 69.4496C32.0234 70.9225 34.0211 71.75 36.1042 71.75H63.8958C65.9789 71.75 67.9766 70.9225 69.4496 69.4496C70.9225 67.9766 71.75 65.9789 71.75 63.8958V36.1042C71.75 34.0211 70.9225 32.0234 69.4496 30.5504C67.9766 29.0775 65.9789 28.25 63.8958 28.25H36.1042ZM31.875 36.1042C31.875 33.7697 33.7697 31.875 36.1042 31.875H63.8958C66.2303 31.875 68.125 33.7697 68.125 36.1042V63.8958C68.125 65.0175 67.6794 66.0932 66.8863 66.8863C66.0932 67.6794 65.0175 68.125 63.8958 68.125H36.1042C34.9825 68.125 33.9068 67.6794 33.1137 66.8863C32.3206 66.0932 31.875 65.0175 31.875 63.8958V36.1042Z",
    fill: "#5959C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_4243",
    x: 3,
    y: 3,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_4243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_4243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11_4243",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_4243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_4243",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupMessage);
export default __webpack_public_path__ + "static/media/popup-message.f88733d7730c10b641f8cdd76cff1642.svg";
export { ForwardRef as ReactComponent };